import VueSlider from 'vue-slider-component';
import Histogram from 'v-charts/lib/histogram.common';
import Pie from 'v-charts/lib/pie.common';
import Tree from 'v-charts/lib/tree.common';
import Line from 'v-charts/lib/line.common';
import Radar from 'v-charts/lib/radar.common';

export default Vue => {
  Vue.component('VueSlider', VueSlider);
  // v-charts  按需引入
  Vue.component('Histogram', Histogram);
  Vue.component('Pie', Pie);
  Vue.component('Line', Line);
  Vue.component('vTree', Tree);
  Vue.component('Radar', Radar);
};
